import { RecordCategory, RecordModel } from './../../layout/record-model';
import {
  Section,
  Field,
  ModuleStructure,
  FieldDataType,
} from './../module-structure';
import { RecordLine } from 'src/app/layout/record-model';
import { BillOfMaterialService } from './../../services/BillOfMaterial.service';
import { LineDeletedArgs } from './../lineDeletedArgs';
import { NzMessageService } from 'ng-zorro-antd/message';
import { LayoutService } from './../../layout/layout.service';
import { FieldValueChangedArgs } from 'src/app/layout/field-value-changed-args';
import * as g from 'src/app/globals';
import { ModuleHeaderDataPayload } from '../module-header-data-payload';
import { tap } from 'rxjs/operators';
import { Guid } from '../guid';
export class BillOfMaterials {
  fieldsToDisableForBOM = '';
  lineItemTypeFieldName = 'U_ITM_BWEB_ITM_TYP';

  global = g;

  constructor(
    private layoutService: LayoutService,
    private messageService: NzMessageService,
    private billOfMaterialService: BillOfMaterialService,
    private listenToEvent: boolean = true,
  ) {
    if (!listenToEvent) {
      return;
    }

    this.layoutService.deleteRowEmitter.subscribe((args) => {
      //console.log(args);
      this.IsGoingToBeRemoved(args);
    });

    this.layoutService.bomParentfieldValueChanged.subscribe(
      (args: FieldValueChangedArgs) => {
        var propsToCheck = g.childPropertiesShouldMatchParent.split(',');
        if (propsToCheck.indexOf(args.recordProperty.FieldName) !== -1) {
          const lineNumber = args.line;
          const categories = args.recordModel.Categories;
          const item = categories
            .find((x) => x.Id === 'Document_Lines')
            .Lines.find((l) => l.Id === lineNumber);
          const treeType = item.Properties.find(
            (d) => d.Name === 'TreeType',
          )?.ValueAsObject;
          const parentItemCode = item.Properties.find(
            (a) => a.Name === 'ItemCode',
          )?.ValueAsObject;
          const propVal = args.recordProperty.ValueAsObject;

          if (treeType === 'iSalesTree' || treeType === 'S') {
            const recordCategory = categories.find(
              (x) => x.Id === 'Document_Lines',
            );
            var lines = recordCategory.Lines;
            const indexNumber = lines.findIndex((l) => l.Id === lineNumber);
            for (let index = indexNumber + 1; index < lines.length; index++) {
              const v = lines[index];
              if (!v.TreeTypeProp) {
                v.TreeTypeProp = v.Properties.find(
                  (p) => p.Name === 'TreeType',
                );
              }

              const baseItemCode = v.Properties.find(
                (s) => s.Name === 'U_ITM_BWEB_PARENT_ITEM',
              ).ValueAsObject;
              if (
                baseItemCode === parentItemCode &&
                (v.TreeTypeProp.ValueAsObject === 'I' ||
                  v.TreeTypeProp.ValueAsObject === 'iIngredient')
              ) {
                const toChangeProperty = v.Properties.find(
                  (k) => k.Name === args.recordProperty.Name,
                );

                LayoutService.setValue(
                  toChangeProperty,
                  propVal,
                  this.layoutService,
                  args.recordModel,
                  v.Id,
                  'Document_Lines',
                  args.moduleStructure,
                  true,
                );

                let field = null;

                for (const section of args.moduleStructure.module.Sections) {
                  if (section.Fields) {
                    field = section.Fields.find(
                      (f) => f.Id === toChangeProperty.FieldId,
                    );
                    if (field) break; // Exit loop once the field is found
                  }
                }

                if (
                  toChangeProperty.DataType === FieldDataType.Select &&
                  field
                ) {
                  RecordModel.getOptions(
                    field,
                    args.recordModel,
                    toChangeProperty,
                    'Document_Lines',
                    v.Id,
                    recordCategory,
                    this.layoutService,
                    args.moduleStructure,
                  );
                }

                // toChangeProperty.ValueAsObject = propVal;
                // toChangeProperty.Value = propVal;
                toChangeProperty.ReadOnly = true;
              } else {
                break;
              }
            }
          } else if (
            this.global.updateQuantitiesForTemplateBOM &&
            (treeType === 'iTemplateTree' || treeType === 'T')
          ) {
            console.log(args);
            var lines = categories.find((x) => x.Id === 'Document_Lines').Lines;
            const indexNumber = lines.findIndex((l) => l.Id === lineNumber);
            for (let index = indexNumber + 1; index < lines.length; index++) {
              const v = lines[index];
              const baseItemCode = v.Properties.find(
                (s) => s.Name === 'U_ITM_BWEB_PARENT_ITEM',
              ).ValueAsObject;
              if (baseItemCode === parentItemCode) {
                const toChangeProperty = v.Properties.find(
                  (k) => k.Name === args.recordProperty.Name,
                );
                LayoutService.setValue(
                  toChangeProperty,
                  propVal,
                  this.layoutService,
                  args.recordModel,
                  v.Id,
                  args.sectionTagName,
                  args.moduleStructure,
                );
              } else {
                break;
              }
            }
          }
        }
        try {
          if (
            args.recordProperty.Name === 'ItemCode' &&
            args.sectionTagName === 'Document_Lines'
          ) {
            this.LoadBOMItems(args);
          }
        } catch (e) {
          console.log('Error while trying to load the boms', e);
        }
      },
    );

    this.layoutService.fieldValueChanged.subscribe(
      (args: FieldValueChangedArgs) => {
        if (args.recordProperty === undefined) return;
        var propsToCheck = g.childPropertiesShouldMatchParent.split(',');
        if (args.recordProperty.FieldName === 'Quantity') {
          this.updateQuantites(args);
        } else if (propsToCheck.indexOf(args.recordProperty.FieldName) !== -1) {
          const lineNumber = args.line;
          const categories = args.recordModel.Categories;
          const item = categories
            .find((x) => x.Id === 'Document_Lines')
            .Lines.find((l) => l.Id === lineNumber);
          const treeType = item.Properties.find(
            (d) => d.Name === 'TreeType',
          )?.ValueAsObject;
          const parentItemCode = item.Properties.find(
            (a) => a.Name === 'ItemCode',
          )?.ValueAsObject;
          const propVal = args.recordProperty.ValueAsObject;

          if (treeType === 'iSalesTree' || treeType === 'S') {
            const recordCategory = categories.find(
              (x) => x.Id === 'Document_Lines',
            );
            var lines = recordCategory.Lines;
            const indexNumber = lines.findIndex((l) => l.Id === lineNumber);
            for (let index = indexNumber + 1; index < lines.length; index++) {
              const v = lines[index];
              if (!v.TreeTypeProp) {
                v.TreeTypeProp = v.Properties.find(
                  (p) => p.Name === 'TreeType',
                );
              }

              const baseItemCode = v.Properties.find(
                (s) => s.Name === 'U_ITM_BWEB_PARENT_ITEM',
              ).ValueAsObject;
              if (
                baseItemCode === parentItemCode &&
                (v.TreeTypeProp.ValueAsObject === 'I' ||
                  v.TreeTypeProp.ValueAsObject === 'iIngredient')
              ) {
                const toChangeProperty = v.Properties.find(
                  (k) => k.Name === args.recordProperty.Name,
                );

                LayoutService.setValue(
                  toChangeProperty,
                  propVal,
                  this.layoutService,
                  args.recordModel,
                  v.Id,
                  'Document_Lines',
                  args.moduleStructure,
                  true,
                );

                let field = null;

                for (const section of args.moduleStructure.module.Sections) {
                  if (section.Fields) {
                    field = section.Fields.find(
                      (f) => f.Id === toChangeProperty.FieldId,
                    );
                    if (field) break; // Exit loop once the field is found
                  }
                }

                if (
                  toChangeProperty.DataType === FieldDataType.Select &&
                  field
                ) {
                  RecordModel.getOptions(
                    field,
                    args.recordModel,
                    toChangeProperty,
                    'Document_Lines',
                    v.Id,
                    recordCategory,
                    this.layoutService,
                    args.moduleStructure,
                  );
                }

                // toChangeProperty.ValueAsObject = propVal;
                // toChangeProperty.Value = propVal;
                toChangeProperty.ReadOnly = true;
              } else {
                break;
              }
            }
          } else if (
            this.global.updateQuantitiesForTemplateBOM &&
            (treeType === 'iTemplateTree' || treeType === 'T')
          ) {
            console.log(args);
            var lines = categories.find((x) => x.Id === 'Document_Lines').Lines;
            const indexNumber = lines.findIndex((l) => l.Id === lineNumber);
            for (let index = indexNumber + 1; index < lines.length; index++) {
              const v = lines[index];
              const baseItemCode = v.Properties.find(
                (s) => s.Name === 'U_ITM_BWEB_PARENT_ITEM',
              ).ValueAsObject;
              if (baseItemCode === parentItemCode) {
                const toChangeProperty = v.Properties.find(
                  (k) => k.Name === args.recordProperty.Name,
                );
                LayoutService.setValue(
                  toChangeProperty,
                  propVal,
                  this.layoutService,
                  args.recordModel,
                  v.Id,
                  args.sectionTagName,
                  args.moduleStructure,
                );
              } else {
                break;
              }
            }
          }
        }
        try {
          if (
            args.recordProperty.Name === 'ItemCode' &&
            args.sectionTagName === 'Document_Lines'
          ) {
            this.LoadBOMItems(args);
          }
        } catch (e) {
          console.log('Error while trying to load the boms', e);
        }
      },
    );

    this.layoutService.objectLoadChanged.subscribe(
      (data: {
        moduleStructure: ModuleStructure;
        recordModel: RecordModel;
      }) => {
        this.objectLoad(data);
      },
    );
  }

  updateQuantites(args: FieldValueChangedArgs) {
    const lineNumber = args.line;
    const categories = args.recordModel.Categories;
    if (
      categories.find((x) => x.Id === 'Document_Lines') == null ||
      categories.find((x) => x.Id === 'Document_Lines') === undefined
    ) {
      return;
    }
    const item = categories
      .find((x) => x.Id === 'Document_Lines')
      .Lines.find((l) => l.Id === lineNumber);
    const treeType = item.Properties.find(
      (d) => d.Name === 'TreeType',
    )?.ValueAsObject;
    const parentItemCode = item.Properties.find(
      (a) => a.Name === 'ItemCode',
    )?.ValueAsObject;
    const quantity: number = args.recordProperty.ValueAsObject;

    if (treeType === 'iSalesTree' || treeType === 'S') {
      console.log(args);
      var lines = categories.find((x) => x.Id === 'Document_Lines').Lines;
      const indexNumber = lines.findIndex((l) => l.Id === lineNumber);
      for (let index = indexNumber + 1; index < lines.length; index++) {
        const v = lines[index];
        const baseItemCode = v.Properties.find(
          //(s) => s.Name === 'ITM_BOM_BASE_BaseItem'
          (s) => s.Name === 'U_ITM_BWEB_PARENT_ITEM',
        ).ValueAsObject;
        const childItemCode = v.Properties.find(
          //(s) => s.Name === 'ITM_BOM_BASE_BaseItem'
          (s) => s.Name === 'ItemCode',
        ).ValueAsObject;
        if (baseItemCode === parentItemCode) {
          let baseQuantity: number = v.Properties.find(
            //(p) => p.Name === 'ITM_BOM_BASE_BaseQuantity'
            (p) => p.Name === 'U_ITM_BWEB_BOM_QTY',
          ).ValueAsObject;
          if (isNaN(baseQuantity)) {
            baseQuantity = Number(
              v.Properties.find(
                //(p) => p.Name === 'ITM_BOM_BASE_BaseQuantity'
                (p) => p.Name === 'U_ITM_BWEB_BOM_QTY',
              ).Value,
            );
          }
          if (baseQuantity === 0) {
            this.layoutService
              .executeQuery(100116, {
                ParentCode: parentItemCode,
                ChildCode: childItemCode,
              })
              .subscribe((result: any[]) => {
                if (
                  result.length > 0 &&
                  result[0].Quantity != null &&
                  result[0].Quantity !== undefined
                ) {
                  v.Properties.find(
                    //(p) => p.Name === 'ITM_BOM_BASE_BaseQuantity'
                    (p) => p.Name === 'U_ITM_BWEB_BOM_QTY',
                  ).ValueAsObject = result[0].Quantity;
                  const newQuantity: number = result[0].Quantity * quantity;
                  const quantityProperty = v.Properties.find(
                    (k) => k.Name === 'Quantity',
                  );
                  LayoutService.setValue(
                    quantityProperty,
                    newQuantity,
                    this.layoutService,
                    args.recordModel,
                    v.Id,
                    args.sectionTagName,
                    args.moduleStructure,
                  );
                }
              });
          } else {
            const newQuantity: number = baseQuantity * quantity;
            const quantityProperty = v.Properties.find(
              (k) => k.Name === 'Quantity',
            );
            LayoutService.setValue(
              quantityProperty,
              newQuantity,
              this.layoutService,
              args.recordModel,
              v.Id,
              args.sectionTagName,
              args.moduleStructure,
            );
          }
        } else {
          break;
        }
      }
    } else if (
      this.global.updateQuantitiesForTemplateBOM &&
      (treeType === 'iTemplateTree' || treeType === 'T')
    ) {
      console.log(args);
      var lines = categories.find((x) => x.Id === 'Document_Lines').Lines;
      const indexNumber = lines.findIndex((l) => l.Id === lineNumber);
      for (let index = indexNumber + 1; index < lines.length; index++) {
        const v = lines[index];
        const baseItemCode = v.Properties.find(
          //(s) => s.Name === 'ITM_BOM_BASE_BaseItem'
          (s) => s.Name === 'U_ITM_BWEB_PARENT_ITEM',
        ).ValueAsObject;
        if (baseItemCode === parentItemCode) {
          const baseQuantity: number = v.Properties.find(
            //(p) => p.Name === 'ITM_BOM_BASE_BaseQuantity'
            (p) => p.Name === 'U_ITM_BWEB_BOM_QTY',
          ).ValueAsObject;
          const newQuantity: number = baseQuantity * quantity;
          const quantityProperty = v.Properties.find(
            (k) => k.Name === 'Quantity',
          );
          LayoutService.setValue(
            quantityProperty,
            newQuantity,
            this.layoutService,
            args.recordModel,
            v.Id,
            args.sectionTagName,
            args.moduleStructure,
          );
        } else {
          break;
        }
      }
    }
  }

  IsGoingToBeRemoved(args: LineDeletedArgs) {
    if (args.lineToDeleteIndex === -1) {
      return;
    }

    args.recordCategory.DeletedLines = [];
    const properties = args.lineToDelete.Properties;
    const treeTypeProp = properties.find((p) => p.Name === 'TreeType');
    if (treeTypeProp === undefined) {
      return;
    }
    const treeTypeValue = treeTypeProp?.ValueAsObject;
    if (treeTypeValue === 'I' || treeTypeValue === 'iIngrediant') {
      return;
    }

    const treeType = properties.find(
      (p) => p.Name === 'TreeType',
    ).ValueAsObject;
    const parentItem = properties.find(
      (p) => p.Name === 'ItemCode',
    ).ValueAsObject;
    const index = args.lineToDeleteIndex;
    if (treeType === 'iSalesTree' || treeType === 'S') {
      let count = 0;
      let finished = false;
      let lineToCheckIndex = 0;
      args.recordCategory.Lines.forEach((lineToHandle) => {
        if (finished || lineToCheckIndex++ <= index - 1) {
          return;
        }

        const baseItem = lineToHandle.Properties.find(
          //(p) => p.Name === 'ITM_BOM_BASE_BaseItem'
          (p) => p.Name === 'U_ITM_BWEB_PARENT_ITEM',
        ).ValueAsObject;
        if (
          (lineToHandle.TreeTypeProp.ValueAsObject === 'iIngredient' ||
            lineToHandle.TreeTypeProp.ValueAsObject === 'I') &&
          baseItem === parentItem
        ) {
          console.log('lineToHandle>', lineToHandle.ItemCodeProp.ValueAsObject);
          args.recordCategory.DeletedLines.push(lineToHandle);
          count++;
        } else {
          finished = true;
          return false;
        }
      });

      const deletedLines = args.recordCategory.DeletedLines;
      deletedLines.forEach((deletedLine) => {
        console.log(deletedLine.Id);
        this.billOfMaterialService.deleteLineEmitter.emit({
          Id: deletedLine.Id,
          FormGUID: args.recordModel.FormGUID,
        });
      });
    }
  }

  LoadBOMItems(args: FieldValueChangedArgs): void {
    // debugger;
    const category = args.recordModel.Categories.find(
      (c) => c.Id === args.sectionTagName,
    );

    const section = args.moduleStructure.module.Sections.find(
      (c) => c.XmlTagName === args.sectionTagName,
    );

    const baseLine = category.Lines.find((l) => l.Id === args.line);
    const treeTypeValue = baseLine.Properties.find(
      (f) => f.Name === 'TreeType',
    )?.ValueAsObject;
    if (treeTypeValue === 'I' || treeTypeValue === 'iIngrediant') {
      return;
    }

    const baseItemCode = args.recordProperty.ValueAsObject;
    const parentItemNo = baseLine.Properties.find(
      (f) => f.Name === 'U_ITM_BWEB_PARENT_ITEM',
    )?.ValueAsObject;
    let parentGuid = baseLine.Properties.find(
      (f) => f.Name === 'U_ITM_BWEB_LINE_GUID',
    )?.ValueAsObject;

    if (
      baseLine.Properties.find((f) => f.Name === 'U_ITM_BWEB_LINE_GUID') &&
      parentGuid === ''
    ) {
      parentGuid = baseLine.Properties.find(
        (f) => f.Name === 'U_ITM_BWEB_LINE_GUID',
      ).ValueAsObject = Guid.newGuid();
    }

    if (parentItemNo !== '') {
      return;
    }

    const linesToDelete = [];
    category.Lines.forEach((l) => {
      if (l.Id <= baseLine.Id) {
        return;
      } else {
        const childGuid = l.Properties.find(
          (f) => f.Name === 'U_ITM_BWEB_PARENT_GUID',
        ).ValueAsObject;
        if (parentGuid === childGuid) {
          if (category.DeletedLines == null) {
            category.DeletedLines = [];
          }
          linesToDelete.push(l);
        } else {
          return false;
        }
      }
    });

    if (args.parentComponent != null && g.showSpinnerWhenAddingBOM) {
      args.parentComponent.bomLoading = true;
    }

    linesToDelete.forEach((l) => {
      //this.billOfMaterialService.deleteLineEmitter.emit(l.Id);
      this.billOfMaterialService.deleteLineEmitter.emit({
        Id: l.Id,
        FormGUID: args.recordModel.FormGUID,
      });
    });

    this.billOfMaterialService
      .loadBomChilds(baseItemCode)
      .subscribe((result: any) => {
        if (result.length === 0) {
          if (args.parentComponent != null) {
            args.parentComponent.bomLoading = false;
          }

          return;
        }

        const productDataRequest = [];
        const baseLineIndex = category.Lines.indexOf(baseLine);
        const hideComp = result.rows[0].HideComp;
        const treeType = result.rows[0].TreeType;

        if (treeType !== 'T' && treeType !== 'S') {
          return;
        }

        const baseItemType = baseLine.Properties.find(
          (p) => p.Name === 'TreeType',
        ).ValueAsObject;

        const baseQuantity = baseLine.Properties.find(
          (p) => p.Name === 'Quantity',
        ).ValueAsObject;

        // if item was from template
        if (treeType === 'T') {
          baseLine.Properties.find((p) => p.Name === 'TreeType').ValueAsObject =
            'iTemplateTree';

          this.layoutService.triggerFieldValueChanged({
            recordModel: args.recordModel,
            recordProperty: baseLine.Properties.find(
              (p) => p.Name === 'TreeType',
            ),
            formId: '',
            line: baseLine.Id,
            sectionTagName: 'Document_Lines',
            moduleStructure: args.moduleStructure,
            internalTrigger: true,
            parentComponent: args.parentComponent,
          });
        } // else it is sales
        else {
          baseLine.Properties.find((p) => p.Name === 'TreeType').ValueAsObject =
            'iSalesTree';

          this.layoutService.triggerFieldValueChanged({
            recordModel: args.recordModel,
            recordProperty: baseLine.Properties.find(
              (p) => p.Name === 'TreeType',
            ),
            formId: '',
            line: baseLine.Id,
            sectionTagName: 'Document_Lines',
            moduleStructure: args.moduleStructure,
            internalTrigger: true,
            parentComponent: args.parentComponent,
          });
        }
        // line.Properties.find(x => x.Name === 'ITM_BOM_BASE_HideComp').ValueAsObject = hideComp;
        if (
          hideComp === 'N' &&
          (treeType === 'S' || treeType === 'iSalesTree')
        ) {
          baseLine.Properties.find((x) => x.Name === 'UnitPrice').ReadOnly =
            true;
        }

        var propsToCheck = g.childPropertiesShouldMatchParent.split(',');
        // iterate from child items
        let counter = 0;
        for (let i = result.length - 1; i >= 0; i--) {
          const childNum = result.rows[i].ChildNum;
          const childCode = result.rows[i].ChildCode;
          const quantity = result.rows[i].Quantity;
          let section: Section;
          let field: Field;
          //console.log(args);

          args.moduleStructure.module.Sections.forEach((sectionData) => {
            if (sectionData.XmlTagName !== args.sectionTagName) {
              return;
            }

            const foundedField = sectionData.Fields.find(
              (f) => f.PropertyName === args.recordProperty.Name,
            );
            if (foundedField !== undefined) {
              field = foundedField;
              section = sectionData;
            }
          });
          const newLine = RecordLine.addNewLine(
            args.recordModel,
            section,
            undefined,
            args.moduleStructure.defaultValues,
            args.moduleStructure,
            this.layoutService,
            baseLineIndex + counter + 1,
          );
          counter++;

          propsToCheck.forEach((p) => {
            const pro = newLine.Properties.find((a) => a.Name === p);
            if (pro) {
              pro.ReadOnly = true;
            }
          });

          if (treeType === 'T' || treeType === 'iTemplateTree') {
            newLine.Properties.find(
              (x) => x.Name === 'TreeType',
            ).ValueAsObject = 'iNotATree';
          } else {
            newLine.Properties.find(
              (f) => f.Name === 'TreeType',
            ).ValueAsObject = 'I';
            newLine.Properties.find((f) => f.Name === 'ItemCode').ReadOnly =
              true;
            newLine.Properties.find(
              (f) => f.Name === 'ItemDescription',
            ).ReadOnly = true;
            newLine.Properties.find((f) => f.Name === 'Quantity').ReadOnly =
              true;
          }

          newLine.Properties.find((f) => f.Name === 'Quantity').ValueAsObject =
            quantity * baseQuantity;
          newLine.Properties.find(
            (f) => f.Name === 'U_ITM_BWEB_BOM_QTY',
          ).ValueAsObject = quantity;
          newLine.Properties.find(
            (f) => f.Name === 'U_ITM_BWEB_PARENT_GUID',
          ).ValueAsObject = baseLine.Properties.find(
            (x) => x.Name === 'U_ITM_BWEB_LINE_GUID',
          ).ValueAsObject;

          newLine.Properties.find(
            (f) => f.Name === 'U_ITM_BWEB_PARENT_ITEM',
          ).ValueAsObject = baseItemCode;

          if (
            newLine.Properties.find((f) => f.Name === 'U_ITM_BOM_ChildNum') !=
              null &&
            newLine.Properties.find((f) => f.Name === 'U_ITM_BOM_ChildNum') !==
              undefined
          ) {
            newLine.Properties.find(
              (f) => f.Name === 'U_ITM_BOM_ChildNum',
            ).ValueAsObject = childNum;
          }

          newLine.Properties.find(
            (f) => f.Name === 'ITM_BOM_BASE_HideComp',
          ).ValueAsObject = hideComp;

          if (hideComp === 'Y') {
            newLine.Properties.find(
              (x) => x.Name === 'UnitPrice',
            ).ValueAsObject = 0;
            newLine.Properties.find((x) => x.Name === 'UnitPrice').ReadOnly =
              true;
          }

          productDataRequest.push({
            newLine,
            childCode,
            field,
            args,
            treeType,
          });

          if (field.FieldName === 'ItemCode') {
            this.checkWarningOnChange(
              childCode,
              baseItemCode,
              args,
              category,
              field,
              newLine,
            );
          }
        }

        this.layoutService.loadModuleData(
          4,
          productDataRequest,
          this.baseProperties,
          true,
          false,
          args.parentComponent,
        );

        /*setTimeout(() => {
          this.layoutService.afterLoadBom.emit({
            recordLine: baseLine,
            moduleStructure: args.moduleStructure,
            section: section,
            recordModel: args.recordModel,
          });
        }, 2000);*/
      });
  }

  checkWarningOnChange(
    itemCode: string,
    baseItemCode: string,
    args: FieldValueChangedArgs,
    recordCategory: RecordCategory,
    field,
    recordLine,
  ) {
    setTimeout(() => {
      let warningQueryIdToExecute =
        field.AdditionalInformationParsed.WarningMsgOnValueChangeQuery;
      if (warningQueryIdToExecute != null && warningQueryIdToExecute !== 0) {
        this.layoutService
          .getWarningMsgOnValueChange(
            args.recordModel,
            recordCategory,
            recordLine,
            warningQueryIdToExecute,
            field,
            args.moduleStructure,
          )
          .subscribe((result: any[]) => {
            if (result && result.length > 0) {
              let msg = result[0].Value;
              if (msg != null && msg !== undefined && msg !== '') {
                this.layoutService.notification.warning(
                  this.layoutService.translate('System Message'),
                  'Kit: ' +
                    baseItemCode +
                    '<br/>Component: ' +
                    itemCode +
                    ' ' +
                    this.layoutService.translate(msg),
                  { nzDuration: 4000 },
                );
              }
            }
          });
      }
    }, 1500);
  }

  baseProperties: string[] = [];

  objectLoad(form: {
    moduleStructure: ModuleStructure;
    recordModel: RecordModel;
  }) {
    if (
      form.recordModel.Categories.find((x) => x.Id === 'Document_Lines') ===
      undefined
    ) {
      return;
    }

    //new
    this.baseProperties = [];
    form.moduleStructure.module.Sections.forEach((sec) => {
      sec.Fields.forEach((field) => {
        const paramsNames = g.queriesData[field.SQLStatementId];

        let parentProperties = field.ParentProperties;
        if (paramsNames !== undefined) {
          for (const paramsName of paramsNames) {
            if (this.baseProperties.indexOf(paramsName) === -1) {
              this.baseProperties.push(paramsName);
            }
          }
        }
      });
    });
    //

    const currentObject = form.recordModel.ObjectKey;
    const table = form.recordModel.Categories.find(
      (x) => x.Id === 'Document_Lines',
    ).Lines;

    let lastSalesBOM;
    let parentItemCode;
    let hideComp;
    let quantity;
    table.forEach((line) => {
      const treeTypeProp = line.Properties.find((d) => d.Name === 'TreeType');
      if (treeTypeProp === undefined) {
        return;
      }
      const treeType = treeTypeProp.ValueAsObject;
      if (treeType === 'iSalesTree' || treeType === 'S') {
        lastSalesBOM = line;
        parentItemCode = line.Properties.find(
          (x) => x.Name === 'ItemCode',
        ).ValueAsObject;
        hideComp = line.Properties.find(
          (x) => x.Name === 'ITM_BOM_BASE_HideComp',
        ).ValueAsObject;
        quantity = line.Properties.find(
          (x) => x.Name === 'Quantity',
        ).ValueAsObject;

        // line.Properties.find(x => x.Name === 'ITM_BOM_BASE_HideComp').ValueAsObject = '';
      } else if (treeType === 'iIngredient' || treeType === 'I') {
        const currentQuantity = line.Properties.find(
          (x) => x.Name === 'Quantity',
        ).ValueAsObject;
        line.Properties.find(
          //(x) => x.Name === 'ITM_BOM_BASE_BaseItem'
          (x) => x.Name === 'U_ITM_BWEB_PARENT_ITEM',
        ).ValueAsObject = parentItemCode;
        line.Properties.find(
          (x) => x.Name === 'ITM_BOM_BASE_HideComp',
        ).ValueAsObject = hideComp;
        line.Properties.find(
          //(x) => x.Name === 'ITM_BOM_BASE_BaseQuantity'
          (x) => x.Name === 'U_ITM_BWEB_BOM_QTY',
        ).ValueAsObject = currentQuantity / quantity;
        line.Properties.find((x) => x.Name === 'ItemCode').ReadOnly = true;
        line.Properties.find((x) => x.Name === 'ItemDescription').ReadOnly =
          true;
        if (hideComp === 'Y') {
          line.Properties.find((x) => x.Name === 'UnitPrice').ReadOnly = true;
        }
      }
    });
  }

  static validateBeforeSubmit(recordModel: RecordModel) {
    const categories = recordModel.Categories;

    var lines = categories.find((x) => x.Id === 'Document_Lines').Lines;
    for (let index = 0; index < lines.length; index++) {
      const v = lines[index];

      const treeType = v.Properties.find(
        (d) => d.Name === 'TreeType',
      )?.ValueAsObject;

      if (treeType === 'iTemplateTree' || treeType === 'T') {
        v.Properties.find((d) => d.Name === 'TreeType').ValueAsObject =
          'iNotATree';
      }

      const itmTreeType = v.Properties.find(
        (d) => d.Name === 'U_ITM_BWEB_ITM_TYP',
      )?.ValueAsObject;

      if (itmTreeType === 'iTemplateTree' || itmTreeType === 'T') {
        v.Properties.find(
          (d) => d.Name === 'U_ITM_BWEB_ITM_TYP',
        ).ValueAsObject = 'N';
      }
    }
  }
}
